import { cosignatureRequestsTyped } from "@/api/(requests)/cosignatureTyped";
import type { CosignMetaBody } from "@/core/types";

export async function getAddendumCosignMeta(documentId: string): Promise<CosignMetaBody> {
  return cosignatureRequestsTyped.get_addendum_cosign_meta({ urlParams: { documentId } });
}
